import { render, staticRenderFns } from "./payGateWay.vue?vue&type=template&id=0ecf696c&"
import script from "./payGateWay.vue?vue&type=script&lang=js&"
export * from "./payGateWay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports